<div class="container-fluid from-top">
    <div infiniteScroll [infiniteScrollDistance]="2" (scrolled)="onScroll()">
        <app-waterfall-selection [assets]="assets" [title]="'gen_bookmarks'" (onDelete)="onDelete($event)"></app-waterfall-selection>
    </div>
</div>